import request from '@/CommonDP/utils/request';

export default {
  // 获取视图库类型树
  getViewManagementTree(enterpriseId) {
    return request
      .get(`/view/getViewManagementTree?enterpriseId=${enterpriseId}`)
      .then((res) => res);
  },
  // 视图类型列表
  getViewFile(params) {
    return request.post(`/view/getViewFile`, params).then((res) => res);
  },
  // 添加视图类型
  addViewManagement(params) {
    return request.post(`/view/addViewManagement`, params).then((res) => res);
  },
  // 修改视图类型
  updateViewManagement(params) {
    return request.post(`/view/updateViewManagement`, params).then((res) => res);
  },
  // 删除视图类型
  deleteViewManagement(viewId) {
    return request
      .get(`/view/deleteViewManagement?viewId=${viewId}`)
      .then((res) => res);
  },
  // 删除视图文件
  deleteViewFile(params) {
    return request.post(`/view/deleteViewFile`, params).then((res) => res);
  },
  //
  getViewDocByEnterpriseId(enterpriseId) {
    return request
      .get(`/view/getViewDocByEnterpriseId?enterpriseId=${enterpriseId}`)
      .then((res) => res);
  },
  // 修改视图文件(名称)
  updateFamilyRecord(params) {
    return request.post(`/view/updateViewFile`, params).then((res) => res);
  }

};
